import { motion } from 'motion/react';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionHomeHeaderTopBlockProps extends PropsWithChildren {
  className?: string;
}

export const MotionHomeHeaderTopBlock = ({
  className,
  children,
  ...props
}: MotionHomeHeaderTopBlockProps) => {
  return (
    <MotionHomeHeaderTopBlockWrapper
      {...props}
      className={className}
      initial={{
        opacity: 0,
        y: ANIMATION_CONFIG.homeHeader.topBlock.yOffset,
        x: ANIMATION_CONFIG.homeHeader.topBlock.xOffset,
      }}
      animate={{ opacity: 1, y: 0, x: 0 }}
      transition={{
        duration: ANIMATION_CONFIG.homeHeader.topBlock.duration,
        delay: ANIMATION_CONFIG.homeHeader.topBlock.delay,
        ease: 'easeIn',
        type: 'spring',
      }}
    >
      {children}
    </MotionHomeHeaderTopBlockWrapper>
  );
};

const MotionHomeHeaderTopBlockWrapper = styled(motion.div)``;
